<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        prepend-inner-icon="mdi-clock-time-four-outline"
        :value="showTime"
        :label="label"
        readonly
        :solo="solo"
        v-bind="attrs"
        v-on="!readonly ? on : null"
        :hide-details="hideDetails"
        :dense="dense"
        :disabled="disabled"
        :error-messages="errorMessages"
        :clearable="!readonly"
        @click:clear="clearMe()"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="menu"
      v-model="innerValue"
      :readonly="readonly"
      :use-seconds="false"
      :min="min"
      :max="max"
    >
      <v-spacer></v-spacer>
      <v-btn text @click="menu = false"> Cancel </v-btn>
      <v-btn text color="info" @click="$refs.menu.save(innerValue)">
        OK
      </v-btn>
    </v-time-picker>
  </v-menu>
</template>

<script>
// import moment from "moment";

export default {
  props: {
    min: String,
    max: String,
    solo: Boolean,
    hideDetails: Boolean,
    dense: Boolean,
    value: [String],
    label: String,
    errorMessages: [Array],
    blur: [Function, Object],
    disabled: Boolean,
    readonly: Boolean,
    fullyClear: Boolean,
  },

  data() {
    return {
      menu: false,
      modal: false,
      menu2: false,
      innerValue: this.value,
    };
  },

  computed: {
    showTime() {
      if (this.innerValue) {
        return this.convert(this.innerValue);
      } else {
        return this.fullyClear ? "" : "00:00";
      }
    },
  },

  methods: {
    convert(time) {
      // Check correct time format and split into components
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join(""); // return adjusted time or original string
    },
    clearMe() {
      if (!this.innerValue || this.innerValue.length !== 5 || this.fullyClear) {
        this.innerValue = null;
      }
      this.$emit("onClear");
    },
  },

  created() {
    this.$on("blur", this.blur);
  },
  watch: {
    value(n) {
      const fallbackValue = this.fullyClear ? null : "00:00";
      this.innerValue = n || fallbackValue;
    },
    innerValue(value) {
      this.$emit("input", value);
    },
  },
};
</script>